
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { Reference } from '@sanity/types';
import SanityBlockContent from '~/components/Sanity/SanityBlockContent.vue';
import SanityDocument from '~/components/Sanity/SanityDocument.vue';
import SanityRowHeroVideo from '~/components/Sanity/SanityRowHeroVideo.vue';
import ProjectDetailsSkeletonLoader from './ProjectDetailsSkeletonLoader.vue';
import PersonCard from './PersonCard.vue';
import ProjectMediaCarousel from './ProjectMediaCarousel.vue';
import ProjectTimeline from './ProjectTimeline.vue';
import {
  ISanityDocuments,
  SanityDocumentSchema,
  ProjectPageVariation,
} from '~/types/sanity-documents';
import { ISanityObjects, SanityObjectSchema } from '~/types/sanity-objects';

interface ICrewGroup {
  department?: Reference;
  members: ISanityObjects[SanityObjectSchema.CREW_MEMBER][];
}

@Component({
  components: {
    PersonCard,
    ProjectDetailsSkeletonLoader,
    ProjectMediaCarousel,
    ProjectTimeline,
    SanityBlockContent,
    SanityDocument,
    SanityRowHeroVideo,
  },
})
export default class ProjectAboutTab extends Vue {
  @Prop(Boolean) readonly loading!: boolean;
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.PROJECT];

  schemas = SanityDocumentSchema;
  obj = SanityObjectSchema;
  variations = ProjectPageVariation;

  get variation() {
    return this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
  }

  get heroVideo() {
    return this.doc?.heroVideo;
  }

  get isHeroLayout() {
    return this.$vuetify.breakpoint.width >= 775;
  }

  get castMembers() {
    return this.doc?.castMembers || [];
  }

  get crewMembers() {
    if (!this.doc?.crewMembers) {
      return;
    }

    const groups = new Map<string, ICrewGroup>();
    this.doc.crewMembers.forEach((member) => {
      const groupKey = member?.department?._ref || 'none';
      const group = groups.get(groupKey) || {
        department: member.department,
        members: [],
      };
      group.members.push(member);
      groups.set(groupKey, group);
    });
    return groups;
  }

  get details() {
    return this.doc?.details;
  }

  get figures() {
    return this.doc?.figures || [];
  }

  get timeline() {
    return this.doc?.projectTimeline?.timeline;
  }

  get timelineCurrentStep() {
    return this.doc?.projectTimeline?.currentStep;
  }

  get videos() {
    return this.doc?.videos || [];
  }
}
